import React from 'react';

import config from '../../config';
import { navigateTop } from '../routing/router-utils';
import { trackEvent } from '../analytics/tracking'; 
import { DispensaryContext } from '../dispensary/DispensaryProvider';
import ButtonWithPrice from '../styleguide/ButtonWithPrice';
import DisabledButtonWithReason from '../styleguide/DisabledButtonWithReason';
import PropTypes from 'prop-types';

import styles from './ReOrder.module.css';

/**
 * Display REORDER Checkout button with price for pickup orders
 */
const CheckOutPickupButton = ({ 
  itemTotal=0, 
  onCheckoutClick
}) => {
  
  // Dipensary info from the provider
  const { dispensary: { 
    id: dispensaryId,
    name: dispensaryName,
    minimum_pickup_value_usa_cents: minOrderPickup
  }} = React.useContext(DispensaryContext);

  // Check config for disabled/paused ordering
  const isOrderingPaused = config.PAUSED_DISPENSARIES.includes(dispensaryId);
  const [minOrderMet, setMinOrderMet] = React.useState();

  // Format for display
  const [itemTotalDisplay, setItemTotalDisplay] = React.useState('0');
  const minOrder = parseFloat(minOrderPickup/100).toFixed(2);

  // Proceed to /placeOrder
  const proceedToCheckout = () => {
    if (onCheckoutClick) {
      // Add products to cart
      onCheckoutClick();
    }
    navigateTop(`/placeOrder/${dispensaryId}`);
    trackEvent('reorder_checkout_click');
  };
 
  React.useEffect(() => {
    setMinOrderMet(itemTotal >= minOrderPickup);
    const itemTotalFloat = parseFloat(itemTotal/100).toFixed(2);
    setItemTotalDisplay(itemTotalFloat);
  }, [itemTotal, itemTotalDisplay, minOrderMet, minOrderPickup])

  return(
    <>
      { isOrderingPaused
        ? <DisabledButtonWithReason text="Checkout" isFullWidth 
              reason={`Online ordering is currently paused for ${dispensaryName}`} /> 
        : minOrderMet 
          ? <ButtonWithPrice text="Checkout" price={itemTotalDisplay} handleClick={proceedToCheckout} />
          : <div className={styles.disabledMsg}>
              <ButtonWithPrice text="Checkout" disabled price={itemTotalDisplay} handleClick={()=>{}} />
              <sup>*</sup> 
              Minimum pickup order: ${minOrder}
            </div>
      }
    </>
  )
}

CheckOutPickupButton.propTypes = {
  itemTotal: PropTypes.number.isRequired,
  onCheckoutClick: PropTypes.func
};

export default CheckOutPickupButton;